module.exports = __webpack_public_path__ + "img/sophia_kunkel_cxlcuy_u4SuW.437ba09d.jpg";